import React from 'react';

export const InfoIcon = () => (
  <svg
    className="coupon-card__badge-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Info.icon.jsx